import { setNativeFocused } from './set-native-focused';
import { getClosestFocusable } from './get-closest-focusable';

export function moveFocusInside(target: HTMLElement): HTMLElement | null {
  const focusable = getClosestFocusable({
    initial: target,
    root: target,
  });

  if (focusable) {
    setNativeFocused(focusable, true);
    return focusable;
  }

  return null;
}
